import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useIsLoggedOn } from "../../../../../stores/hooks/useIsLoggedOn";
import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { RadioButton } from "../../../../../ui/RadioButton/RadioButton";
import { useOriginalEquipment } from "./useOriginalEquipment";
import { useOriginalEquipmentOptions } from "./useOriginalEquipmentOptions";
import { useOriginalEquipmentSettings } from "./useOriginalEquipmentSettings";

const id = "dealer-tire-original-equipment-panel";

export const TireOriginalEquipmentFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const options = useOriginalEquipmentOptions();
  const [, toggle] = useOriginalEquipment();
  const isLoggedOn = useIsLoggedOn();
  const {
    useOriginalEquipmentOnlyFilter,
    useOriginalEquipmentOnlyFilterWhenAuhenticated,
  } = useOriginalEquipmentSettings();

  const shouldRender = isLoggedOn
    ? useOriginalEquipmentOnlyFilterWhenAuhenticated
    : useOriginalEquipmentOnlyFilter;

  if (!shouldRender) {
    return null;
  }
  return (
    <Collapsible
      className="space-y-2"
      id={id}
      label={t("searchResults.originalEquipment")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, label, value }) => (
        <label className="flex gap-x-4" key={value}>
          <RadioButton
            onChange={(): void => {
              toggle(value);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            name="brand"
          />
          <span className="flex-1">{label}</span>
        </label>
      ))}
    </Collapsible>
  );
};
